/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6), __webpack_require__(0), __webpack_require__(1), __webpack_require__(5)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, helper) {
    'use strict';

    hypotheticalGrowth.$inject = ["mstarDebounce"];
    angular.module('ecHypotheticalGrowth', ['mstarCore', 'ecButton', 'ecContainer', 'ecInput', 'ecPerformanceGraph', 'ecPortfolioData', 'ecReportBuilder']).directive('ecHypotheticalGrowth', hypotheticalGrowth);

    function hypotheticalGrowth(mstarDebounce) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope, { editable: true });
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var currentActiveView,
                hypoTabsInstance = scope.instance.findRelative('performanceGraph.tabFrequency'),
                hypoApplyButtonInstance = scope.instance.findRelative('hypoApplyButton'),
                hypoDateInputInstance = scope.instance.findRelative('hypoDateInput'),
                hypoFeesApplyChosenInstance = scope.instance.findRelative('hypoFeesApplyChosen'),
                hypoReinvestChosenInstance = scope.instance.findRelative('hypoReinvestChosen'),
                hypoSettingsButtonInstance = scope.instance.findRelative('hypoSettingsButton'),
                hypoTimePeriodTrailingReturnChosenInstance = scope.instance.findRelative('hypoTimePeriodTrailingReturnChosen'),
                portfolioDataInstance = scope.instance.findRelative('portfolioData');

            scope.isLoading = portfolioDataInstance.getModelProperty('securities')._$isLoading;

            initializeHypotheticalDataSettingsModel();

            scope.hypotheticalSettingsRenderStatus = false;

            scope.timePeriodRadioChange = function () {
                var illustrationTrailingTimePeriod = helper.getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
                updateTimePeriodInstanceStatus(illustrationTrailingTimePeriod);
            };

            scope.selectHypoViewSection = function (activeView) {
                var newChosen = !helper.getHypotheticalDataModelProperty(scope, activeView, 'chosen'),
                    selectHypoViewSectionData = helper.generateSelectHypoViewSectionData(scope, activeView, newChosen);

                toggleCurrentActiveView(activeView, selectHypoViewSectionData.data, newChosen);
                setHypotheticalDataSettingsModelProperty(selectHypoViewSectionData, false);
            };

            scope.toggleActiveHypoViewSection = function (activeView) {
                var newToggle = !helper.getHypotheticalDataModelProperty(scope, activeView, 'toggle'),
                    toggleActiveHypoViewSectionData = helper.generateToggleActiveHypoViewSectionData(scope, activeView, newToggle);

                toggleCurrentActiveView(activeView, toggleActiveHypoViewSectionData.data, newToggle);
                setHypotheticalDataSettingsModelProperty(toggleActiveHypoViewSectionData, false);
            };

            mstarComponent.addUnregisterCallback(hypoTabsInstance.on('parameterChanged:selectedTabIndex', function (selectedTabIndex) {
                if (selectedTabIndex >= 0) {
                    if (scope.model.sections.showHypotheticalSettings) {
                        updateHypotheticalSettingsButton();
                    }
                    var timePeriodType = getTimePeriodType(selectedTabIndex);
                    var hypotheticalDataSettings = {
                        data: {
                            all: {
                                chosen: true
                            },
                            timePeriod: {
                                toggle: true,
                                chosen: true,
                                illustrationTrailingTimePeriod: timePeriodType,
                                trailingReturn: getTrailingReturnValue(selectedTabIndex, timePeriodType),
                                startDate: null,
                                endDate: null
                            }
                        },
                        settings: {
                            illustrationTrailingTimePeriod: timePeriodType
                        }
                    };
                    if (currentActiveView && currentActiveView !== 'timePeriod') {
                        hypotheticalDataSettings.data[currentActiveView] = {
                            toggle: false
                        };
                    }
                    currentActiveView = 'timePeriod';
                    setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, false);
                    updateTimePeriodInstanceStatus(timePeriodType);
                    updateHypoSettingsToReportBuilderPortfolioData(helper.generateHypotheticalSettings(scope));
                }
            }));

            mstarComponent.addUnregisterCallback(portfolioDataInstance.on('modelPropertyChanged:securities', function (securities) {
                if (securities) {
                    scope.isLoading = securities._$isLoading;
                }
            }));

            mstarComponent.addUnregisterCallback(hypoSettingsButtonInstance.on('click', function () {
                if (!scope.hypotheticalSettingsRenderStatus) {
                    scope.hypotheticalSettingsRenderStatus = true;
                }
                updateHypotheticalSettingsButton();
            }));

            mstarComponent.addUnregisterCallback(hypoApplyButtonInstance.on('click', function () {
                updateHypotheticalSettingsButton();
                var hypotheticalSettings = helper.generateHypotheticalSettings(scope);
                updateHypoSettingsToReportBuilderPortfolioData(hypotheticalSettings);
                setActiveTabIndex(hypotheticalSettings.illustrationTrailingTimePeriod);
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoNumberInput').on('ecInputChanged', mstarDebounce(function (value) {
                var isInvalidValue = !_.isNumber(value) && _.isEmpty(value);
                hypoApplyButtonInstance.setParameter('disabled', isInvalidValue);
                if (!isInvalidValue) {
                    var numperInputData = helper.validateNumperInputData(scope, scope.instance.getModelProperty('hypotheticalDataSettings.settings'));
                    setHypotheticalDataSettingsModelProperty(numperInputData, false);
                }
            }, 1000)));

            mstarComponent.addUnregisterCallback(hypoDateInputInstance.on('ecInputChanged', mstarDebounce(function (date) {
                updateTimePeriodCustomDateStatus();
            }, 300)));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoFilingStatusChosen').on('ecChosenItemSelected', function (filingStatus) {
                if (filingStatus) {
                    var defaultTaxRateData = helper.generateDefaultTaxRateData(scope, filingStatus);
                    setHypotheticalDataSettingsModelProperty(defaultTaxRateData, false);
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoSubsequentInvestmentTypeChosen').on('ecChosenItemSelected', function (subsequentInvestmentType) {
                if (subsequentInvestmentType) {
                    var subsequentInvestmentAmount = 0.00;
                    if (subsequentInvestmentType === scope.settings.get('hypotheticalSettings').subsequentInvestmentType) {
                        subsequentInvestmentAmount = scope.settings.get('hypotheticalSettings').subsequentInvestmentAmount;
                    }
                    setHypotheticalDataSettingsModelProperty({
                        settings: {
                            subsequentInvestmentAmount: scope.format.number(subsequentInvestmentAmount, 'shortDecimal')
                        }
                    }, false);
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypoFrontLoadTypeChosen').on('ecChosenItemSelected', function (frontLoadType) {
                if (frontLoadType) {
                    updateFeesInstanceStatus(frontLoadType);
                    var feesDataSettings = helper.generateFeesDataSettings(scope, frontLoadType);
                    setHypotheticalDataSettingsModelProperty(feesDataSettings, false);
                }
            }));

            mstarComponent.addUnregisterCallback(hypoFeesApplyChosenInstance.on('ecChosenItemSelected', function (applies) {
                updateCheckboxChosenData(hypoFeesApplyChosenInstance, applies);
            }));

            mstarComponent.addUnregisterCallback(hypoReinvestChosenInstance.on('ecChosenItemSelected', function (applies) {
                updateCheckboxChosenData(hypoReinvestChosenInstance, applies);
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:hypotheticalSettings', function (hypotheticalSettings) {
                if (hypotheticalSettings) {
                    var newHypotheticalDataSettings = helper.generateHypotheticalDataSettings(scope, hypotheticalSettings);
                    setActiveTabIndex(newHypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
                    updateTimePeriodInstanceStatus(newHypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod);
                    updateFeesInstanceStatus(newHypotheticalDataSettings.settings.frontLoadType);
                    setHypotheticalDataSettingsModelProperty(newHypotheticalDataSettings, false);
                    portfolioDataInstance.setParameter('hypotheticalSettings', helper.merge(scope.settings.get('hypotheticalSettings'), hypotheticalSettings));
                }
            }));

            function initializeHypotheticalDataSettingsModel() {
                var hypotheticalDataSettings = helper.generateDefaultHypotheticalDataSettings(scope, 'all', false);
                setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, true);
                setActiveTabIndex(hypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
                updateTimePeriodInstanceStatus(hypotheticalDataSettings.settings.illustrationTrailingTimePeriod);
                updateFeesInstanceStatus(hypotheticalDataSettings.settings.frontLoadType);
                updateHypoSettingsToReportBuilderPortfolioData(hypotheticalDataSettings.settings);
            }

            function getTimePeriodType(index) {
                var timePeriodType;
                var isTrailingReturn = _.indexOf(scope.settings.get('trailingReturnDefinitions'), scope.parameters.displayFrequency[index].value);
                if (isTrailingReturn > -1) {
                    timePeriodType = 'TrailingReturn';
                } else {
                    timePeriodType = scope.parameters.displayFrequency[index].value;
                }
                return timePeriodType;
            }

            function getTrailingReturnValue(index, timePeriodType) {
                var trailingReturnValue;
                if (timePeriodType === 'TrailingReturn') {
                    trailingReturnValue = scope.parameters.displayFrequency[index].value;
                } else {
                    trailingReturnValue = '';
                }
                return trailingReturnValue;
            }

            function setHypotheticalDataSettingsModelProperty(hypotheticalDataSettings, reset) {
                if (hypotheticalDataSettings) {
                    if (reset) {
                        scope.instance.setModelProperty('hypotheticalDataSettings', helper.merge({}, hypotheticalDataSettings));
                    } else {
                        scope.instance.setModelProperty('hypotheticalDataSettings', helper.merge(scope.instance.getModelProperty('hypotheticalDataSettings'), hypotheticalDataSettings));
                    }
                }
            }

            function setActiveTabIndex(illustrationTrailingTimePeriod) {
                var selectedTabIndex = -1;
                _.each(scope.parameters.displayFrequency, function (item, index) {
                    if (item.value === illustrationTrailingTimePeriod) {
                        selectedTabIndex = index;
                        return;
                    }
                });
                hypoTabsInstance.setParameter('selectedTabIndex', selectedTabIndex);
                if (selectedTabIndex === -1 && hypoTabsInstance.isActive) {
                    hypoTabsInstance.setParameter('resetTabStatus', true);
                }
            }

            function updateFeesInstanceStatus(frontLoadType) {
                if (frontLoadType) {
                    var listItems = hypoFeesApplyChosenInstance.getModelProperty('listItems') || [],
                        applySalesChargeItem = _.findWhere(listItems, { key: 'applySalesCharge' });
                    if (applySalesChargeItem) {
                        applySalesChargeItem.disabled = frontLoadType === 'Standard' || frontLoadType === 'LetterOfIntent';
                        hypoFeesApplyChosenInstance.setModelProperty('listItems', listItems);
                    }
                }
            }

            function updateCheckboxChosenData(chosenInstance, data) {
                var listItems = chosenInstance.getModelProperty('listItems') || [],
                    hypotheticalSettings = scope.instance.getModelProperty('hypotheticalDataSettings.settings');
                _.each(listItems, function (item) {
                    hypotheticalSettings[item.key] = _.indexOf(data, item.key) > -1;
                });

                scope.instance.setModelProperty('hypotheticalDataSettings.settings', hypotheticalSettings);
            }

            function updateHypoSettingsToReportBuilderPortfolioData(hypotheticalSettings) {
                portfolioDataInstance.setParameter('hypotheticalSettings', hypotheticalSettings);
                scope.instance.findRelative('hypoReportBuilder').setModelProperty('reportInfo.reportSettings.RequestSettings.HypoCalculationSettings', hypotheticalSettings);
            }

            function updateTimePeriodInstanceStatus(illustrationTrailingTimePeriod) {
                if (illustrationTrailingTimePeriod) {
                    hypoDateInputInstance.setParameter('disabled', true);
                    hypoTimePeriodTrailingReturnChosenInstance.setParameter('disabled', true);
                    hypoApplyButtonInstance.setParameter('disabled', false);
                    if (illustrationTrailingTimePeriod === 'TrailingReturn') {
                        hypoTimePeriodTrailingReturnChosenInstance.setParameter('disabled', false);
                    } else if (illustrationTrailingTimePeriod === 'Customized') {
                        hypoDateInputInstance.setParameter('disabled', false);
                        updateTimePeriodCustomDateStatus();
                    }
                }
            }

            function updateTimePeriodCustomDateStatus() {
                var timePeriodDateInputData = helper.validateTimePeriodDateInputData(scope, helper.getHypotheticalDataModelProperty(scope, 'timePeriod'));
                setHypotheticalDataSettingsModelProperty(timePeriodDateInputData, false);
                hypoApplyButtonInstance.setParameter('disabled', timePeriodDateInputData.data.timePeriod.showDateErrorMsg);
            }

            function toggleCurrentActiveView(activeView, data, status) {
                if (activeView !== 'all') {
                    if (status) {
                        if (currentActiveView) {
                            data[currentActiveView] = data[currentActiveView] || {};
                            data[currentActiveView].toggle = false;
                        }
                        currentActiveView = activeView;
                    } else {
                        currentActiveView = activeView !== currentActiveView ? currentActiveView : null;
                    }
                } else {
                    currentActiveView = null;
                }
            }

            function updateHypotheticalSettingsButton() {
                scope.model.sections.showHypotheticalSettings = !scope.model.sections.showHypotheticalSettings;

                var captionLabelKey;
                if (scope.model.sections.showHypotheticalSettings) {
                    captionLabelKey = 'settingsHide';
                } else {
                    captionLabelKey = 'settingsShow';
                }
                hypoSettingsButtonInstance.setParameter('captionLabelKey', captionLabelKey);
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = {
	"ecHypotheticalGrowth": {
		"components": {
			"containerHypo": {
				"settings": {
					"breakpoints": {
						"defaults": {
							"groups": {
								"all": {
									"cols": 12,
									"sections": [
										{
											"cols": 2,
											"sectionId": "hypoReportBuilder"
										},
										{
											"cols": 2,
											"sectionId": "hypotheticalSettings"
										},
										"performanceGraph"
									]
								}
							}
						},
						"small": {
							"groups": {
								"all": {
									"cols": 12,
									"sections": [
										{
											"cols": 0,
											"sectionId": "hypoReportBuilder"
										},
										{
											"cols": 1,
											"sectionId": "hypotheticalSettings"
										},
										"performanceGraph"
									]
								}
							}
						}
					}
				},
				"type": "ecContainer"
			},
			"hypoApplyButton": {
				"labels": {
					"caption": {
						"en": "Apply"
					}
				},
				"settings": {
					"buttonCSS": "ec-button__btn--apply"
				},
				"type": "ecButton"
			},
			"hypoChosenButton": {
				"labels": {
					"caption": {
						"en": " "
					}
				},
				"settings": {
					"buttonCSS": "ec-button__btn--on-off"
				},
				"type": "ecButton"
			},
			"hypoDateInput": {
				"labels": {
					"placeholder": {
						"en": "YYYY-MM-DD"
					}
				},
				"settings": {
					"inputType": "date"
				},
				"type": "ecInput"
			},
			"hypoFeesApplyChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"disabled": true,
								"key": "applySalesCharge",
								"value": "applySalesCharge"
							},
							{
								"key": "applyFeeForRebalance",
								"value": "applyFeeForRebalance"
							}
						]
					},
					"controlType": "checkbox",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoFilingStatusChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "Single",
								"value": "single"
							},
							{
								"key": "MarriedFilingJointly",
								"value": "marriedFilingJointly"
							},
							{
								"key": "MarriedFilingSeparately",
								"value": "marriedFilingSeparately"
							},
							{
								"key": "HeadOfHousehold",
								"value": "headOfHousehold"
							}
						]
					},
					"controlType": "radio",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoFrequencyChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "Monthly",
								"value": "monthly"
							},
							{
								"key": "Quarterly",
								"value": "quarterly"
							},
							{
								"key": "SemiAnnually",
								"value": "semiAnnually"
							},
							{
								"key": "Annually",
								"value": "annually"
							}
						]
					},
					"controlType": "radio",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoFrontLoadTypeChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "Standard",
								"value": "standard"
							},
							{
								"key": "Custom",
								"value": "customCurrency"
							},
							{
								"key": "CustomEntry",
								"value": "customPercenatge"
							},
							{
								"key": "LetterOfIntent",
								"value": "letterOfIntent"
							}
						]
					},
					"controlType": "radio",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoNumberInput": {
				"settings": {
					"_validation": {
						"rules": {
							"isRegex": {
								"labelKey": "numberInputErrorMsg",
								"pattern": "^[0-9.,]+$",
								"type": "regex"
							}
						},
						"tooltipWhen": "never"
					},
					"inputType": "text"
				},
				"type": "ecInput"
			},
			"hypoPayChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "OutOfPocket",
								"value": "outOfPocket"
							},
							{
								"key": "SalesOfShares",
								"value": "saleOfShares"
							}
						]
					},
					"controlType": "radio",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoReinvestChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "reinvestDividends",
								"value": "reinvestDividends"
							},
							{
								"key": "reinvestCapitalGains",
								"value": "reinvestCapitalGains"
							}
						]
					},
					"controlType": "checkbox",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoReportBuilder": {
				"blueprint": "standardUSHypo",
				"settings": {
					"_model": {
						"reportInfo": {
							"reportContents": [
								"historicalPerformance"
							],
							"reportPortfolios": {
								"dataSourceType": "selector",
								"selector": "{{_ model(_.portfolioData).securities.portfolio _}}"
							}
						}
					},
					"reportSettings": {
						"Config": {
							"Id": "PDF"
						},
						"View": {
							"Id": "PDF"
						}
					}
				},
				"type": "ecReportBuilder"
			},
			"hypoSettingsButton": {
				"labels": {
					"caption": {
						"en": "Show Settings"
					}
				},
				"settings": {
					"buttonCSS": "ec-button__btn--bar"
				},
				"type": "ecButton"
			},
			"hypoSubsequentInvestmentTypeChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "Invest",
								"value": "contribution"
							},
							{
								"key": "Withdrawal",
								"value": "withdrawal"
							},
							{
								"key": "WithdrawalPercentage",
								"value": "withdrawalPercentage"
							}
						]
					},
					"controlType": "radio",
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"hypoTimePeriodTrailingReturnChosen": {
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "Year1",
								"value": "oneYearTrailingReturn"
							},
							{
								"key": "Year3",
								"value": "threeYearsTrailingReturn"
							},
							{
								"key": "Year5",
								"value": "fiveYearsTrailingReturn"
							},
							{
								"key": "Year10",
								"value": "tenYearsTrailingReturn"
							}
						]
					},
					"allowSingleDeselect": false,
					"disableSearch": true,
					"displayFirstEmptyOption": false,
					"width": "100%"
				},
				"type": "ecChosen"
			},
			"performanceGraph": {
				"components": {
					"annualPerformanceTable": {
						"components": {
							"paginator": {
								"type": "ecPaginator"
							},
							"paginatorSticky": {
								"type": "ecPaginator"
							},
							"paginatorTop": {
								"type": "ecPaginator"
							},
							"sortFieldsDropdown": {
								"type": "ecChosen"
							},
							"sortOrderRadio": {
								"type": "ecChosen"
							}
						},
						"type": "ecTable"
					},
					"graphContainer": {
						"settings": {
							"breakpoints": {
								"defaults": {
									"groups": {
										"main": {
											"sections": [
												"frequency",
												"graph"
											]
										}
									}
								}
							}
						},
						"type": "ecContainer"
					},
					"tabFrequency": {
						"settings": {
							"selectedTabIndex": -1
						},
						"type": "ecTabs"
					}
				},
				"labels": {
					"performanceGraph": {
						"en": " "
					}
				},
				"settings": {
					"_model": {
						"performanceChart": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_.portfolioData).securities.performanceChart _}}"
						}
					},
					"_parameters": {
						"displayFrequency": {
							"binding": "{{_ parameters(_).displayFrequency _}}"
						}
					},
					"chartType": "price",
					"colorPalettes": {
						"lineChart": [
							"#A50032",
							"#006098"
						]
					},
					"lineChartSettings": {
						"legendValuesFormatAlias": "currencyDecimal",
						"showsCurrency": true
					}
				},
				"type": "ecPerformanceGraph"
			},
			"portfolioData": {
				"blueprint": "standardHypo",
				"settings": {
					"_parameters": {
						"portfolio": {
							"binding": "{{_ parameters(_).portfolio _}}"
						}
					}
				},
				"type": "ecPortfolioData"
			}
		},
		"labels": {
			"amount": {
				"en": "Amount",
				"en-GB": null,
				"sv-SE": null
			},
			"annually": {
				"en": "Annually",
				"en-GB": null,
				"sv-SE": null
			},
			"applyFeeForRebalance": {
				"en": "Apply Fees for Rebalancing",
				"en-GB": null,
				"sv-SE": null
			},
			"applySalesCharge": {
				"en": "Redemption/Deferred Sales Charge",
				"en-GB": null,
				"sv-SE": null
			},
			"assetBasedAnnualFee": {
				"en": "Asset-Based Annual Fee %",
				"en-GB": null,
				"sv-SE": null
			},
			"benchmark": {
				"en": "Benchmark"
			},
			"capitalGain": {
				"en": "Capital Gain %",
				"en-GB": null,
				"sv-SE": null
			},
			"contribution": {
				"en": "Contribution",
				"en-GB": null,
				"sv-SE": null
			},
			"custom": {
				"en": "Custom",
				"en-GB": null,
				"sv-SE": null
			},
			"customCurrency": {
				"en": "Custom Currency",
				"en-GB": null,
				"sv-SE": null
			},
			"customDateErrorMsg": {
				"en": "Start date must be less than End date",
				"en-GB": null,
				"sv-SE": null
			},
			"customPercenatge": {
				"en": "Custom Percenatge",
				"en-GB": null,
				"sv-SE": null
			},
			"earliestAvailable": {
				"en": "Earliest Available",
				"en-GB": null,
				"sv-SE": null
			},
			"earliestCommon": {
				"en": "Earliest Common",
				"en-GB": null,
				"sv-SE": null
			},
			"endDate": {
				"en": "End Date",
				"en-GB": null,
				"sv-SE": null
			},
			"federalIncome": {
				"en": "Federal Income %",
				"en-GB": null,
				"sv-SE": null
			},
			"fees": {
				"en": "Fees",
				"en-GB": null,
				"sv-SE": null
			},
			"filingStatus": {
				"en": "Filing Status",
				"en-GB": null,
				"sv-SE": null
			},
			"fiveYears": {
				"da-DK": "5 År",
				"en": "5Y",
				"en-GB": null,
				"fr": "5A",
				"sv-SE": null,
				"zh-CN": "5年",
				"zh-HK": "5年"
			},
			"fiveYearsTrailingReturn": {
				"en": "5-Year Trailing Return",
				"en-GB": null,
				"sv-SE": null
			},
			"frequency": {
				"en": "Frequency",
				"en-GB": null,
				"sv-SE": null
			},
			"frontLoadType": {
				"en": "Front Load Type",
				"en-GB": null,
				"sv-SE": null
			},
			"headOfHousehold": {
				"en": "Head Of Household",
				"en-GB": null,
				"sv-SE": null
			},
			"inceptionDate": {
				"en": "Inception Date",
				"en-GB": null,
				"sv-SE": null
			},
			"investmentType": {
				"en": "Investment Type",
				"en-GB": null,
				"sv-SE": null
			},
			"letterOfIntent": {
				"en": "Letter Of Intent",
				"en-GB": null,
				"sv-SE": null
			},
			"marriedFilingJointly": {
				"en": "Married, Filed Jointly",
				"en-GB": null,
				"sv-SE": null
			},
			"marriedFilingSeparately": {
				"en": "Married, Filed Separately",
				"en-GB": null,
				"sv-SE": null
			},
			"monthly": {
				"en": "Monthly",
				"en-GB": null,
				"sv-SE": null
			},
			"numberInputErrorMsg": {
				"en": "Please input a valid value. Such as 123.00 or 123,123.00",
				"en-GB": null,
				"sv-SE": null
			},
			"oneYear": {
				"da-DK": "1 År",
				"en": "1Y",
				"en-GB": null,
				"fr": "1A",
				"sv-SE": null,
				"zh-CN": "1年",
				"zh-HK": "1年"
			},
			"oneYearTrailingReturn": {
				"en": "1-Year Trailing Return",
				"en-GB": null,
				"sv-SE": null
			},
			"outOfPocket": {
				"en": "Out Of Pocket",
				"en-GB": null,
				"sv-SE": null
			},
			"payFees": {
				"en": "How to Pay Fees",
				"en-GB": null,
				"sv-SE": null
			},
			"payTaxes": {
				"en": "Pay Taxes",
				"en-GB": null,
				"sv-SE": null
			},
			"percentage": {
				"en": "%",
				"en-GB": null,
				"sv-SE": null
			},
			"performanceChartInstruction": {
				"en": "Press T to bypass chart and read the corresponding table.",
				"en-GB": null,
				"fr": "Appuyez sur la touche T pour contourner le graphique et lire le tableau correspondant.",
				"sv-SE": null
			},
			"portfolio": {
				"en": "Portfolio",
				"en-GB": null,
				"sv-SE": null
			},
			"quarterly": {
				"en": "Quarterly",
				"en-GB": null,
				"sv-SE": null
			},
			"rebalancingReinvestment": {
				"en": "Rebalancing / Reinvestment",
				"en-GB": null,
				"sv-SE": null
			},
			"reinvestCapitalGains": {
				"en": "Reinvest Capital Gains",
				"en-GB": null,
				"sv-SE": null
			},
			"reinvestDividends": {
				"en": "Reinvest Dividends",
				"en-GB": null,
				"sv-SE": null
			},
			"reportOptions": {
				"en": "Report Options",
				"en-GB": null,
				"sv-SE": null
			},
			"saleOfShares": {
				"en": "Sale Of Shares",
				"en-GB": null,
				"sv-SE": null
			},
			"semiAnnually": {
				"en": "Semi-annually",
				"en-GB": null,
				"sv-SE": null
			},
			"settingsHide": {
				"en": "Hide Settings",
				"en-GB": null,
				"sv-SE": null
			},
			"settingsShow": {
				"en": "Show Settings",
				"en-GB": null,
				"sv-SE": null
			},
			"settingsTitle": {
				"en": "Custom Settings",
				"en-GB": null,
				"sv-SE": null
			},
			"sinceInception": {
				"en": "Since Inception",
				"en-GB": null,
				"sv-SE": null
			},
			"single": {
				"en": "Single",
				"en-GB": null,
				"sv-SE": null
			},
			"standard": {
				"en": "Standard",
				"en-GB": null,
				"sv-SE": null
			},
			"startDate": {
				"en": "Start Date",
				"en-GB": null,
				"sv-SE": null
			},
			"state": {
				"en": "State %",
				"en-GB": null,
				"sv-SE": null
			},
			"symbol": {
				"en": "€",
				"en-GB": null,
				"en-US": "$",
				"sv-SE": null
			},
			"taxInformation": {
				"en": "Tax Information",
				"en-GB": null,
				"sv-SE": null
			},
			"taxableIncome": {
				"en": "Taxable Income",
				"en-GB": null,
				"sv-SE": null
			},
			"tenYears": {
				"da-DK": "10 År",
				"en": "10Y",
				"en-GB": null,
				"fr": "10A",
				"sv-SE": null,
				"zh-CN": "10年",
				"zh-HK": "10年"
			},
			"tenYearsTrailingReturn": {
				"en": "10-Year Trailing Return",
				"en-GB": null,
				"sv-SE": null
			},
			"threeYears": {
				"da-DK": "3 År",
				"en": "3Y",
				"en-GB": null,
				"fr": "3A",
				"sv-SE": null,
				"zh-CN": "3年",
				"zh-HK": "3年"
			},
			"threeYearsTrailingReturn": {
				"en": "3-Year Trailing Return",
				"en-GB": null,
				"sv-SE": null
			},
			"timePeriod": {
				"en": "Time Period",
				"en-GB": null,
				"sv-SE": null
			},
			"title": {
				"en": "Hypothetical Growth",
				"en-GB": null,
				"sv-SE": null
			},
			"withdrawal": {
				"en": "Withdrawal",
				"en-GB": null,
				"sv-SE": null
			},
			"withdrawalPercentage": {
				"en": "Withdrawal%",
				"en-GB": null,
				"sv-SE": null
			}
		},
		"settings": {
			"_model": {
				"hypoDates": {
					"dataSourceType": "selector",
					"selector": "{{_ model(portfolioData).securities.hypoDates _}}"
				},
				"hypotheticalDataSettings": null,
				"sections": {
					"showHypotheticalSettings": false
				}
			},
			"_parameters": {
				"displayFrequency": {},
				"hypotheticalSettings": {},
				"portfolio": {}
			},
			"_templates": {
				"fees": "<div class=\"{{::namespaceClass('__hypothetical-settings--fees')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('assetBasedAnnualFee')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.assetBasedAnnualFee\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.assetBasedAnnualFee\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('frequency')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFrequencyChosen[fees]\" data-ng-model=\"model.hypotheticalDataSettings.settings.assetFeeFrequency\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('payFees')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoPayChosen[fees]\" data-ng-model=\"model.hypotheticalDataSettings.settings.payFeeOptions\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('frontLoadType')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFrontLoadTypeChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.frontLoadType\"></ec-chosen>\r\n        </div>\r\n        <div data-ng-show=\"model.hypotheticalDataSettings.settings.frontLoadType !=='Standard' && model.hypotheticalDataSettings.settings.frontLoadType !=='LetterOfIntent'\" class=\"{{::namespaceClass('__hypothetical-settings--fees-front-load-type-amount')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n                {{::labels.get('amount')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n                <label data-ng-if=\"model.hypotheticalDataSettings.settings.frontLoadType ==='Custom'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                    {{::labels.get('symbol')}}\r\n                </label>\r\n                <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.salesFeeAmount\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n                <label data-ng-if=\"model.hypotheticalDataSettings.settings.frontLoadType ==='CustomEntry'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                    {{::labels.get('percentage')}}\r\n                </label>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.salesFeeAmount\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--checkbox')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFeesApplyChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.fees.applies\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n</div>",
				"investmentType": "<div class=\"{{::namespaceClass('__hypothetical-settings--investment-type')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoSubsequentInvestmentTypeChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType\"></ec-chosen>\r\n            </div>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--investment-type-amount')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}} {{::namespaceClass('__hypothetical-settings--investment-type-amount-title')}}\">\r\n                {{::labels.get('amount')}}\r\n            </label>\r\n            <label data-ng-if=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType !=='WithdrawalPercentage'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('symbol')}}\r\n            </label>\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentAmount\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label data-ng-if=\"model.hypotheticalDataSettings.settings.subsequentInvestmentType ==='WithdrawalPercentage'\" class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.subsequentInvestmentAmount\">\r\n                {{::labels.get('numberInputErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n                {{::labels.get('frequency')}}\r\n            </label>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoFrequencyChosen[investmentType]\" data-ng-model=\"model.hypotheticalDataSettings.settings.subsequentInvestmentWithdrawalFrequency\"></ec-chosen>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>",
				"main": "<ec-section title=\"{{::labels.get('title')}}\">\r\n    <div class=\"{{::namespaceClass('__hidden-text')}}\" tabindex=\"0\">{{::labels.get('performanceChartInstruction')}}</div>\r\n    <ec-container mstar-component-id=\"containerHypo\" mstar-loader=\"settings.get('showLoading') && isLoading\">\r\n        <ec-report-builder mstar-component-id=\"hypoReportBuilder\"></ec-report-builder>\r\n        <ec-section data-template-type=\"light\" section-id=\"hypotheticalSettings\">\r\n            <ec-button mstar-component-id=\"hypoSettingsButton\" class=\"{{model.sections.showHypotheticalSettings ? 'ec-button__btn--icon-arrow-right' : 'ec-button__btn--icon-arrow-left'}}\"></ec-button>\r\n        </ec-section>\r\n        <div data-ng-if=\"hypotheticalSettingsRenderStatus\" data-ng-show=\"model.sections.showHypotheticalSettings\" class=\"{{ ::namespaceClass('__hypothetical-settings--content') }}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}} {{::namespaceClass('__hypothetical-settings--group-settings')}}\">\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-left')}}\">\r\n                    <div class=\"{{::namespaceClass('__hypothetical-settings--group-settings-title')}}\">\r\n                        {{::labels.get('settingsTitle')}}\r\n                    </div>\r\n                </div>\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-right')}}\">\r\n                    <ec-button mstar-component-id=\"hypoChosenButton[all]\" data-ng-click=\"selectHypoViewSection('all')\" class=\"{{ ::namespaceClass('__hypothetical-settings--chosen') }} {{namespaceClass('__hypothetical-settings--chosen-'+ (model.hypotheticalDataSettings.data.all.chosen ? 'on' : 'off')) }}\"></ec-button>\r\n                </div>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}}\" data-ng-repeat=\"view in ::settings.get('hypoViews') track by $index\">\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-left')}}\">\r\n                    <span class=\"{{::namespaceClass('__hypothetical-settings--group-title')}} {{namespaceClass('__hypothetical-settings--group-title-'+ (model.hypotheticalDataSettings.data[view].toggle ? 'open':'close'))}}\" data-ng-click=\"toggleActiveHypoViewSection(view)\">\r\n                            {{::labels.get(view)}}\r\n                        </span>\r\n                    <div data-ng-show=\"model.hypotheticalDataSettings.data[view].toggle\" mstar-include=\"templates[view]\" class=\"{{::namespaceClass('__hypothetical-settings--view')}}\"></div>\r\n                </div>\r\n                <div class=\"{{::namespaceClass('__hypothetical-settings--group-right')}}\">\r\n                    <ec-button mstar-component-id=\"hypoChosenButton[view]\" data-ng-click=\"selectHypoViewSection(view)\" class=\"{{ ::namespaceClass('__hypothetical-settings--chosen') }} {{namespaceClass('__hypothetical-settings--chosen-'+ (model.hypotheticalDataSettings.data[view].chosen ? 'on' : 'off')) }}\"></ec-button>\r\n                </div>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--group')}} {{::namespaceClass('__hypothetical-settings--group-apply')}}\">\r\n                <ec-button mstar-component-id=\"hypoApplyButton\"></ec-button>\r\n            </div>\r\n        </div>\r\n        <ec-performance-graph mstar-component-id=\"performanceGraph\"></ec-performance-graph>\r\n    </ec-container>\r\n</ec-section>\r\n<ec-portfolio-data mstar-component-id=\"portfolioData\"></ec-portfolio-data>",
				"rebalancingReinvestment": "<div class=\"{{::namespaceClass('__hypothetical-settings--rebalancing-reinvestment')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoFrequencyChosen[rebalancing-reinvestment]\" data-ng-model=\"model.hypotheticalDataSettings.settings.rebalanceFrequency\"></ec-chosen>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--checkbox')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoReinvestChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.rebalancingReinvestment.reinvests\"></ec-chosen>\r\n    </div>\r\n</div>",
				"reportOptions": "<div class=\"{{::namespaceClass('__hypothetical-settings--report-options')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <ec-chosen mstar-component-id=\"hypoFrequencyChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.investmentDetailReturnsFrequency\"></ec-chosen>\r\n    </div>\r\n</div>",
				"taxInformation": "<div class=\"{{::namespaceClass('__hypothetical-settings--tax-information')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('filingStatus')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoFilingStatusChosen\" data-ng-model=\"model.hypotheticalDataSettings.settings.filingStatus\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('federalIncome')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.federalIncomeTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.federalIncomeTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('capitalGain')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.capitalGainTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.capitalGainTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('state')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.stateIncomeTaxRate\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('percentage')}}\r\n            </label>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.stateIncomeTaxRate\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('taxableIncome')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--title-mark')}}\">\r\n            <label class=\"{{::namespaceClass('__hypothetical-settings--mark')}}\">\r\n                {{::labels.get('symbol')}}\r\n            </label>\r\n            <ec-input mstar-component-id=\"hypoNumberInput\" data-ng-model=\"model.hypotheticalDataSettings.settings.taxableIncome\" class=\"{{::namespaceClass('__hypothetical-settings--number-input')}}\"></ec-input>\r\n        </div>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"!model.hypotheticalDataSettings.settings.taxableIncome\">\r\n            {{::labels.get('numberInputErrorMsg')}}\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--title')}}\">\r\n            {{::labels.get('payTaxes')}}\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n            <ec-chosen mstar-component-id=\"hypoPayChosen[taxes]\" data-ng-model=\"model.hypotheticalDataSettings.settings.payTaxes\"></ec-chosen>\r\n        </div>\r\n    </div>\r\n</div>",
				"timePeriod": "<div class=\"{{::namespaceClass('__hypothetical-settings--time-period')}}\">\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"EarliestCommon\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('earliestCommon')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-start-date')}}\">\r\n                {{::labels.get('startDate')}}: {{format.date(model.hypoDates.earliestCommonDate,'yyyy-mm-dd')}}\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-end-date')}}\">\r\n                {{::labels.get('endDate')}}: {{format.date(model.hypoDates.asOfDate,'yyyy-mm-dd')}}\r\n            </div>\r\n\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"EarliestAvailable\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('earliestAvailable')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-start-date')}}\">\r\n                {{::labels.get('startDate')}}:{{format.date(model.hypoDates.earliestAvailableDate,'yyyy-mm-dd')}}\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-end-date')}}\">\r\n                {{::labels.get('endDate')}}: {{format.date(model.hypoDates.asOfDate,'yyyy-mm-dd')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"SinceInception\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('sinceInception')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-since-inception-date')}}\">\r\n                {{::labels.get('inceptionDate')}}: {{format.date(model.hypoDates.sinceInceptionDate,'yyyy-mm-dd')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--time-period-trailing-return')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label>\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"TrailingReturn\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--time-period-trailing-return-chosen')}}\">\r\n                <ec-chosen mstar-component-id=\"hypoTimePeriodTrailingReturnChosen\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.trailingReturn\"></ec-chosen>\r\n            </span>\r\n        </label>\r\n    </div>\r\n    <div class=\"{{::namespaceClass('__hypothetical-settings--view-group')}} {{::namespaceClass('__hypothetical-settings--radio')}}\">\r\n        <label class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom')}}\">\r\n            <input type=\"radio\" name=\"{{::namespaceId('time-period-radio')}}\" value=\"Customized\" data-ng-change=\"timePeriodRadioChange()\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.illustrationTrailingTimePeriod\"/>\r\n            <span class=\"{{::namespaceClass('__hypothetical-settings--radio-title')}}\">\r\n                {{::labels.get('custom')}}\r\n            </span>\r\n        </label>\r\n        <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-date')}}\">\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom-start-date')}}\">\r\n                <lable> {{::labels.get('startDate')}} </lable>\r\n                <ec-input mstar-component-id=\"hypoDateInput\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.startDate\" class=\"{{::namespaceClass('__hypothetical-settings--date-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--time-period-custom-end-date')}}\">\r\n                <lable>{{::labels.get('endDate')}}</lable>\r\n                <ec-input mstar-component-id=\"hypoDateInput\" data-ng-model=\"model.hypotheticalDataSettings.data.timePeriod.endDate\" class=\"{{::namespaceClass('__hypothetical-settings--date-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__hypothetical-settings--error')}}\" data-ng-if=\"model.hypotheticalDataSettings.data.timePeriod.showDateErrorMsg\">\r\n                {{::labels.get('customDateErrorMsg')}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>"
			},
			"displayFrequency": [
				{
					"labelKey": "oneYear",
					"value": "Year1"
				},
				{
					"labelKey": "threeYears",
					"value": "Year3"
				},
				{
					"labelKey": "fiveYears",
					"value": "Year5"
				},
				{
					"labelKey": "tenYears",
					"value": "Year10"
				}
			],
			"hypoViewDefinitions": {
				"fees": {
					"dataPoints": [
						"assetBasedAnnualFee",
						"salesFeeAmount",
						"assetFeeFrequency",
						"payFees",
						"payFeeOptions",
						"frontLoadType",
						"customFeeType",
						"applySalesCharge",
						"applyFeeForRebalance"
					],
					"validation": {
						"assetBasedAnnualFee": {
							"dataPoints": [
								"assetBasedAnnualFee"
							],
							"max": 100,
							"min": 0
						},
						"custom": {
							"dataPoints": [
								"salesFeeAmount"
							],
							"min": 0
						},
						"customEntry": {
							"dataPoints": [
								"salesFeeAmount"
							],
							"max": 100,
							"min": 0
						}
					}
				},
				"investmentType": {
					"dataPoints": [
						"subsequentInvestmentType",
						"subsequentInvestmentAmount",
						"subsequentInvestmentWithdrawalFrequency"
					],
					"validation": {
						"invest": {
							"dataPoints": [
								"subsequentInvestmentAmount"
							],
							"min": 0
						},
						"withdrawal": {
							"dataPoints": [
								"subsequentInvestmentAmount"
							],
							"min": 0
						},
						"withdrawalPercentage": {
							"dataPoints": [
								"subsequentInvestmentAmount"
							],
							"max": 100,
							"min": 0
						}
					}
				},
				"rebalancingReinvestment": {
					"dataPoints": [
						"rebalanceFrequency",
						"reinvestDividends",
						"reinvestCapitalGains"
					]
				},
				"reportOptions": {
					"dataPoints": [
						"investmentDetailReturnsFrequency"
					]
				},
				"taxInformation": {
					"dataPoints": [
						"filingStatus",
						"taxableIncome",
						"federalIncomeTaxRate",
						"capitalGainTaxRate",
						"stateIncomeTaxRate",
						"payTaxes"
					],
					"defaultTaxRateData": [
						{
							"capitalGainTaxRate": 0,
							"federalIncomeTaxRate": 0,
							"stateIncomeTaxRate": 0,
							"type": "NoTaxes"
						},
						{
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "Single"
						},
						{
							"capitalGainTaxRate": 5,
							"federalIncomeTaxRate": 15,
							"stateIncomeTaxRate": 0,
							"type": "MarriedFilingJointly"
						},
						{
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "MarriedFilingSeparately"
						},
						{
							"capitalGainTaxRate": 15,
							"federalIncomeTaxRate": 25,
							"stateIncomeTaxRate": 0,
							"type": "HeadOfHousehold"
						}
					],
					"validation": [
						{
							"dataPoints": [
								"federalIncomeTaxRate",
								"capitalGainTaxRate",
								"stateIncomeTaxRate"
							],
							"max": 100,
							"min": 0
						},
						{
							"dataPoints": [
								"taxableIncome"
							],
							"min": 0
						}
					]
				},
				"timePeriod": {
					"dataPoints": [
						"illustrationTrailingTimePeriod",
						"startDate",
						"endDate"
					]
				}
			},
			"hypoViews": [
				"timePeriod",
				"investmentType",
				"fees",
				"rebalancingReinvestment",
				"taxInformation",
				"reportOptions"
			],
			"hypotheticalSettings": {
				"applyFeeForRebalance": false,
				"applySalesCharge": true,
				"assetBasedAnnualFee": 0,
				"assetFeeFrequency": "Annually",
				"assetFeeType": "Percentage",
				"capitalGainTaxRate": 0,
				"customFeeType": "Amount",
				"dividendTaxRate": 0,
				"entryExitFeeType": "CustomEntry",
				"federalIncomeTaxRate": 0,
				"filingStatus": "NoTaxes",
				"frontLoadType": "Standard",
				"illustrationTrailingTimePeriod": "EarliestCommon",
				"investmentDetailReturnsFrequency": "Monthly",
				"liquidateOnEndDate": false,
				"payFeeOptions": "OutOfPocket",
				"payFees": "SalesOfSharesEnding",
				"payFeesUseCashFirst": true,
				"payTaxes": "OutOfPocket",
				"rebalanceFrequency": "None",
				"rebalanceThreshold": 0,
				"reinvestCapitalGains": true,
				"reinvestDividends": true,
				"salesFeeAmount": 0,
				"stateIncomeTaxRate": 0,
				"subsequentInvestmentAmount": 0,
				"subsequentInvestmentType": "Invest",
				"subsequentInvestmentWithdrawalFrequency": "Monthly",
				"synchronizePortfolioStartDate": true,
				"taxableIncome": 50000
			},
			"namespaceClass": "ec-hypothetical-growth",
			"portfolio": null,
			"showLoading": true,
			"trailingReturnDefinitions": [
				"Year1",
				"Year3",
				"Year5",
				"Year10"
			]
		},
		"type": "ecHypotheticalGrowth"
	}
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecHypotheticalGrowth', __webpack_require__(3).ecHypotheticalGrowth);

    morningstar.asterix.meta.register('ecHypotheticalGrowth', 'usageTracking', {
        componentLoad: {
            endsWhen: 'dataLoaded'
        }
    });

    __webpack_require__(2);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    return {
        generateDefaultHypotheticalDataSettings: generateDefaultHypotheticalDataSettings,
        generateDefaultTaxRateData: generateDefaultTaxRateData,
        generateFeesDataSettings: generateFeesDataSettings,
        generateHypotheticalDataSettings: generateHypotheticalDataSettings,
        generateHypotheticalSettings: generateHypotheticalSettings,
        generateSelectHypoViewSectionData: generateSelectHypoViewSectionData,
        generateToggleActiveHypoViewSectionData: generateToggleActiveHypoViewSectionData,
        getHypotheticalDataModelProperty: getHypotheticalDataModelProperty,
        merge: merge,
        validateNumperInputData: validateNumperInputData,
        validateTimePeriodDateInputData: validateTimePeriodDateInputData
    };

    //external
    function generateDefaultHypotheticalDataSettings(scope, view, chosen) {
        var hypotheticalDataSettings = {
            data: {},
            settings: {}
        },
            hypoViewDefinitions = {};

        if (view === 'all') {
            hypoViewDefinitions = scope.settings.get('hypoViewDefinitions');
            hypotheticalDataSettings.data.all = {
                chosen: chosen
            };
        } else {
            hypoViewDefinitions[view] = scope.settings.get('hypoViewDefinitions')[view];
        }

        _.each(hypoViewDefinitions, function (data, key) {
            hypotheticalDataSettings.data[key] = {
                chosen: chosen,
                toggle: false
            };
            if (!chosen) {
                hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, generateHypotheticalDataViewValue(scope, key, scope.settings.get('hypotheticalSettings')));
                hypotheticalDataSettings.settings = merge(hypotheticalDataSettings.settings, generateHypotheticalSettingViewValue(scope, key, scope.settings.get('hypotheticalSettings')));
            }
        });

        return hypotheticalDataSettings;
    }

    function generateDefaultTaxRateData(scope, filingStatus) {
        var capitalGainTaxRate = 0.00,
            federalIncomeTaxRate = 0.00,
            stateIncomeTaxRate = 0.00;
        if (filingStatus === scope.settings.get('hypotheticalSettings').filingStatus) {
            capitalGainTaxRate = scope.settings.get('hypotheticalSettings').capitalGainTaxRate;
            federalIncomeTaxRate = scope.settings.get('hypotheticalSettings').federalIncomeTaxRate;
            stateIncomeTaxRate = scope.settings.get('hypotheticalSettings').stateIncomeTaxRate;
        } else {
            var defaultTaxRateData = morningstar.asterix.util.parse('taxInformation.defaultTaxRateData')(scope.settings.get('hypoViewDefinitions')),
                taxRateData = _.findWhere(defaultTaxRateData, { type: filingStatus });
            if (taxRateData) {
                capitalGainTaxRate = taxRateData.capitalGainTaxRate;
                federalIncomeTaxRate = taxRateData.federalIncomeTaxRate;
                stateIncomeTaxRate = taxRateData.stateIncomeTaxRate;
            }
        }

        return {
            settings: {
                federalIncomeTaxRate: formatNumberValue(scope, federalIncomeTaxRate),
                capitalGainTaxRate: formatNumberValue(scope, capitalGainTaxRate),
                stateIncomeTaxRate: formatNumberValue(scope, stateIncomeTaxRate)
            }
        };
    }

    function generateFeesDataSettings(scope, frontLoadType) {
        var hypotheticalDataSettings;
        if (frontLoadType === 'Standard' || frontLoadType === 'LetterOfIntent') {
            var feesApplies = getHypotheticalDataModelProperty(scope, 'fees', 'applies');
            if (_.indexOf(feesApplies, 'applySalesCharge') === -1) {
                feesApplies.push('applySalesCharge');
                hypotheticalDataSettings = {
                    data: {
                        fees: {
                            applies: feesApplies
                        }
                    },
                    settings: {
                        salesFeeAmount: formatNumberValue(scope, 0)
                    }
                };
            }
        } else {
            hypotheticalDataSettings = {
                settings: {
                    salesFeeAmount: formatNumberValue(scope, frontLoadType === scope.settings.get('hypotheticalSettings').frontLoadType ? scope.settings.get('hypotheticalSettings').salesFeeAmount : 0),
                    customFeeType: frontLoadType === 'Custom' ? 'Amount' : 'Percentage'
                }
            };
        }

        return morningstar.asterix.util.isEmptyObject(hypotheticalDataSettings) ? null : hypotheticalDataSettings;
    }

    function generateHypotheticalDataSettings(scope, hypotheticalSettings) {
        var hypotheticalDataSettings = {
            data: {
                all: {
                    chosen: false
                }
            },
            settings: {}
        },
            newHypotheticalSettings = merge(scope.settings.get('hypotheticalSettings'), hypotheticalSettings);

        _.each(scope.settings.get('hypoViews'), function (view) {
            hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, generateHypotheticalDataViewValue(scope, view, newHypotheticalSettings));
            hypotheticalDataSettings.settings = merge(hypotheticalDataSettings.settings, generateHypotheticalSettingViewValue(scope, view, newHypotheticalSettings));

            var dataPoints = morningstar.asterix.util.parse(view + '.dataPoints')(scope.settings.get('hypoViewDefinitions')) || [];
            _.each(dataPoints, function (dataPoint) {
                if (!_.isUndefined(hypotheticalSettings[dataPoint]) && hypotheticalSettings[dataPoint] !== scope.settings.get('hypotheticalSettings')[dataPoint]) {
                    hypotheticalDataSettings.data[view] = {
                        chosen: true
                    };
                    hypotheticalDataSettings.data.all.chosen = true;
                }
            });
        });

        return hypotheticalDataSettings;
    }

    function generateHypotheticalSettings(scope) {
        var hypotheticalSettings = merge(scope.settings.get('hypotheticalSettings'), getHypotheticalSettingsModelProperty(scope)),
            validations = getAllValidations(scope, hypotheticalSettings);

        if (getHypotheticalDataModelProperty(scope, 'timePeriod', 'chosen')) {
            hypotheticalSettings.illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
            if (hypotheticalSettings.illustrationTrailingTimePeriod !== 'Customized') {
                hypotheticalSettings.startDate = null;
                hypotheticalSettings.endDate = null;
                if (hypotheticalSettings.illustrationTrailingTimePeriod === 'TrailingReturn') {
                    hypotheticalSettings.illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'trailingReturn');
                }
            }
        }
        morningstar.asterix.util.each(validations, function (validation) {
            if (validation) {
                morningstar.asterix.util.each(validation.dataPoints, function (dataPoint) {
                    if (!morningstar.asterix.util.isNumber(hypotheticalSettings[dataPoint])) {
                        hypotheticalSettings[dataPoint] = Number(escapeSquareCommaDot(hypotheticalSettings[dataPoint]));
                    }
                });
            }
        });

        return hypotheticalSettings;
    }

    function generateSelectHypoViewSectionData(scope, activeView, chosen) {
        var hypotheticalDataSettings = generateDefaultHypotheticalDataSettings(scope, activeView, chosen);
        if (activeView !== 'all') {
            hypotheticalDataSettings.data[activeView].toggle = chosen;
            hypotheticalDataSettings.data.all = {
                chosen: chosen
            };
            if (chosen) {
                if (activeView === 'taxInformation') {
                    hypotheticalDataSettings.settings = {
                        filingStatus: 'Single'
                    };
                }
            } else {
                _.each(scope.settings.get('hypoViews'), function (view) {
                    if (view !== activeView) {
                        hypotheticalDataSettings.data.all.chosen = hypotheticalDataSettings.data.all.chosen || getHypotheticalDataModelProperty(scope, view, 'chosen');
                    }
                });
            }
        }

        return hypotheticalDataSettings;
    }

    function generateToggleActiveHypoViewSectionData(scope, activeView, toggle) {
        var hypotheticalDataSettings = {
            data: {}
        };
        hypotheticalDataSettings.data[activeView] = {
            toggle: toggle
        };
        if (toggle) {
            hypotheticalDataSettings.data = merge(hypotheticalDataSettings.data, {
                all: {
                    chosen: true
                }
            });
            hypotheticalDataSettings.data[activeView].chosen = true;
            if (activeView === 'taxInformation' && getHypotheticalSettingsModelProperty(scope, 'filingStatus') === 'NoTaxes') {
                hypotheticalDataSettings.settings = {
                    filingStatus: 'Single'
                };
            }
        }

        return hypotheticalDataSettings;
    }

    function getHypotheticalDataModelProperty(scope, view, dataPoint) {
        if (view && dataPoint) {
            return scope.instance.getModelProperty('hypotheticalDataSettings.data.' + view + '.' + dataPoint);
        } else if (view) {
            return scope.instance.getModelProperty('hypotheticalDataSettings.data.' + view);
        } else {
            return scope.instance.getModelProperty('hypotheticalDataSettings.data');
        }
    }

    function merge(target, source) {
        return morningstar.asterix.util.merge({}, target, source, mergeCustomizer);
    }

    function validateNumperInputData(scope, hypotheticalSettings) {
        var validations = getAllValidations(scope, hypotheticalSettings),
            settings = {};

        _.each(validations, function (validation) {
            if (validation) {
                _.each(validation.dataPoints, function (dataPoint) {
                    var value = escapeSquareCommaDot(hypotheticalSettings[dataPoint]);
                    if (!_.isEmpty(value)) {
                        if (!morningstar.asterix.util.isUndefinedOrNull(validation.min) && Number(value) < validation.min) {
                            settings[dataPoint] = null;
                        } else if (!morningstar.asterix.util.isUndefinedOrNull(validation.max) && Number(value) > validation.max) {
                            settings[dataPoint] = formatNumberValue(scope, validation.max);
                        } else {
                            settings[dataPoint] = formatNumberValue(scope, value);
                        }
                    }
                });
            }
        });

        return morningstar.asterix.util.isEmptyObject(settings) ? null : {
            settings: settings
        };
    }

    /**
     * @param {*} scope 
     * @param {*} timePeriod startdate and endDate must be date object
     */
    function validateTimePeriodDateInputData(scope, timePeriod) {
        var newTimePeriod = {
            showDateErrorMsg: false
        },
            startDate = timePeriod.startDate,
            endDate = timePeriod.endDate;
        var illustrationTrailingTimePeriod = getHypotheticalDataModelProperty(scope, 'timePeriod', 'illustrationTrailingTimePeriod');
        if ((startDate || endDate) && illustrationTrailingTimePeriod === 'Customized') {
            var earliestAvailableDate = new Date(scope.model.hypoDates.earliestAvailableDate),
                asOfDate = new Date(scope.model.hypoDates.asOfDate);

            if (startDate && endDate && endDate <= startDate) {
                newTimePeriod.showDateErrorMsg = true;
            } else if (startDate && !endDate && startDate > asOfDate) {
                newTimePeriod.showDateErrorMsg = true;
            } else {
                if (startDate && startDate < earliestAvailableDate) {
                    timePeriod.startDate = earliestAvailableDate; // correct date in UI
                    startDate = earliestAvailableDate;
                }
                if (endDate && endDate > asOfDate) {
                    timePeriod.endDate = asOfDate; // correct date in UI
                    endDate = asOfDate;
                }
            }
        }
        return {
            data: {
                timePeriod: newTimePeriod
            },
            settings: {
                startDate: !newTimePeriod.showDateErrorMsg && startDate ? morningstar.asterix.util.date.convertToUTC(startDate) : null,
                endDate: !newTimePeriod.showDateErrorMsg && endDate ? morningstar.asterix.util.date.convertToUTC(endDate) : null
            }
        };
    }

    //internal
    function escapeSquareCommaDot(value) {
        //Such as '123,456,789.00' -> '123456789.00'
        //Such as '123.456.789,00' -> '123456789.00'
        if (!morningstar.asterix.util.isUndefinedOrNull(value)) {
            return value.toString().replace(/[.,](?=.*[,.])/g, '').replace(',', '.');
        }
    }

    function formatNumberValue(scope, value) {
        return scope.format.number(value, 'shortDecimal');
    }

    function getAllValidations(scope, hypotheticalSettings) {
        var feesValidation = morningstar.asterix.util.parse('fees.validation')(scope.settings.get('hypoViewDefinitions')),
            investmentTypeValidation = morningstar.asterix.util.parse('investmentType.validation')(scope.settings.get('hypoViewDefinitions')),
            taxInformationValidation = morningstar.asterix.util.parse('taxInformation.validation')(scope.settings.get('hypoViewDefinitions')),
            validations = [];

        validations = validations.concat(taxInformationValidation);
        validations.push(feesValidation.assetBasedAnnualFee);
        validations.push(feesValidation[morningstar.asterix.util.string.firstLowerCase(hypotheticalSettings.frontLoadType)]);
        validations.push(investmentTypeValidation[morningstar.asterix.util.string.firstLowerCase(hypotheticalSettings.subsequentInvestmentType)]);
        return validations;
    }

    function generateHypotheticalDataViewValue(scope, view, hypotheticalSettings) {
        var data;
        switch (view) {
            case 'timePeriod':
                data = generateTimePeriodHypotheticalData(scope, hypotheticalSettings);
                break;
            case 'fees':
                data = generateViewArrayObjectData(scope, hypotheticalSettings, view, 'applies', ['applySalesCharge', 'applyFeeForRebalance']);
                break;
            case 'rebalancingReinvestment':
                data = generateViewArrayObjectData(scope, hypotheticalSettings, view, 'reinvests', ['reinvestDividends', 'reinvestCapitalGains']);
                break;
        }
        return data;
    }

    function generateHypotheticalSettingViewValue(scope, view, hypotheticalSettings) {
        hypotheticalSettings = hypotheticalSettings || {};

        var dataPoints = morningstar.asterix.util.parse(view + '.dataPoints')(scope.settings.get('hypoViewDefinitions')) || [],
            settings = {};
        _.each(dataPoints, function (dataPoint) {
            if (!_.isUndefined(hypotheticalSettings[dataPoint])) {
                settings[dataPoint] = hypotheticalSettings[dataPoint];
            }
        });

        return settings;
    }

    function generateTimePeriodHypotheticalData(scope, hypotheticalSettings) {
        var timePeriod = {};
        if (hypotheticalSettings.illustrationTrailingTimePeriod) {
            if (_.indexOf(scope.settings.get('trailingReturnDefinitions'), hypotheticalSettings.illustrationTrailingTimePeriod) !== -1) {
                timePeriod.illustrationTrailingTimePeriod = 'TrailingReturn';
                timePeriod.trailingReturn = hypotheticalSettings.illustrationTrailingTimePeriod;
            } else {
                timePeriod.illustrationTrailingTimePeriod = hypotheticalSettings.illustrationTrailingTimePeriod;
                timePeriod.trailingReturn = 'Year1';
            }
        }

        _.each(['startDate', 'endDate'], function (item) {
            if (hypotheticalSettings[item]) {
                timePeriod[item] = new Date(hypotheticalSettings[item]);
            }
        });

        return morningstar.asterix.util.isEmptyObject(timePeriod) ? null : {
            timePeriod: timePeriod
        };
    }

    function getHypotheticalSettingsModelProperty(scope, dataPoint) {
        if (dataPoint) {
            return scope.instance.getModelProperty('hypotheticalDataSettings.settings.' + dataPoint);
        } else {
            return scope.instance.getModelProperty('hypotheticalDataSettings.settings');
        }
    }

    function generateViewArrayObjectData(scope, hypotheticalSettings, view, name, dataPoints) {
        var data = {};
        data[view] = {};
        data[view][name] = [];
        _.each(dataPoints, function (dataPoint) {
            if (hypotheticalSettings[dataPoint]) {
                data[view][name].push(dataPoint);
            }
        });

        return data;
    }

    function mergeCustomizer(a, b, key) {
        if (morningstar.asterix.util.isArray(b)) {
            return b;
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ })
/******/ ]);
//# sourceMappingURL=ec-hypothetical-growth.js.map


// WEBPACK FOOTER //
// ./components/hypothetical-growth/build/ec-hypothetical-growth.js